import { render, staticRenderFns } from "./AnnotationDetails.vue?vue&type=template&id=2889f9bd&scoped=true&"
import script from "./AnnotationDetails.vue?vue&type=script&lang=js&"
export * from "./AnnotationDetails.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationDetails.vue?vue&type=style&index=0&id=2889f9bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2889f9bd",
  null
  
)

export default component.exports